module.exports = __webpack_public_path__ + "img/symbol_7.cc6c502c.png";